import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { Button, Form, Input, MessagePlugin, Select } from 'tdesign-react';
import { isVoid, toTsOptions } from '@/utils/common';
import { createFlow, updateFlow } from '@/services/templateService';
import ShadowCard from '@/components/ShadowCard';
import { clusterTypeOptions } from '@/utils/constant';
import NodeList from './NodeList';
import NodeGroup from './NodeGroup';

const { FormItem } = Form;

export default function Detail() {
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [form] = Form.useForm();

  const id = searchParams.get('id');
  const isEdit = !isVoid(id);

  // 流程类型
  const flowType = useMemo(() => {
    const str = searchParams.get('flowType');
    if (isVoid(str)) {
      return null;
    } else return Number(str);
  }, [searchParams]);

  const loadDetail = useMemoizedFn(async () => {
    if (isEdit) {
      const values = Object.fromEntries(searchParams);
      form.setFieldsValue({
        ...values,
        flowType,
      });
    }
  });

  useEffect(() => {
    loadDetail();
  }, [loadDetail]);

  const flowSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      try {
        setLoading(true);
        if (isEdit) {
          const params = {
            ...fields,
            id,
          };
          await updateFlow(params);
          setSearchParams(params);
        } else {
          const { data } = await createFlow(fields);
          setSearchParams({
            id: data.id,
            ...fields,
          });
        }
        MessagePlugin.success('操作成功！');
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Root>
      <ShadowCard style={{ marginBottom: 16 }}>
        <Form form={form} layout='inline' onSubmit={flowSubmit}>
          <FormItem label='流程名称' name='name' rules={[{ required: true }]}>
            <Input style={{ width: 200 }} />
          </FormItem>
          <FormItem label='流程标签' name='tag' rules={[{ required: true }]}>
            <Input style={{ width: 200 }} />
          </FormItem>
          <FormItem label='流程类型' name='flowType' rules={[{ required: true }]}>
            <Select options={toTsOptions(clusterTypeOptions)} />
          </FormItem>
          <FormItem>
            <FormItem label='流程备注' name='note' rules={[{ required: true }]}>
              <Input style={{ width: 200 }} />
            </FormItem>
            <Button loading={loading} type='submit'>
              {isEdit ? '修改' : '创建'}
            </Button>
          </FormItem>
        </Form>
      </ShadowCard>
      {isEdit && (
        <ShadowCard>
          {flowType === 0 && <NodeGroup />}
          <NodeList flowType={flowType} />
        </ShadowCard>
      )}
    </Root>
  );
}

const Root = styled.div`
  padding-right: 20px;
`;
